<template>
  <Bar
    :chart-options="chartOptions"
    :chart-data="chartData"
    :chart-id="chartId"
    :dataset-id-key="datasetIdKey"
    :plugins="plugins"
    :css-classes="cssClasses"
    :styles="styles"
    :width="width"
    :height="height"
  />
</template>

<script>
import { Bar } from "vue-chartjs/legacy";

import {
  Chart as ChartJS,
  Title,
  Tooltip,
  Legend,
  BarElement,
  CategoryScale,
  LinearScale,
} from "chart.js";

ChartJS.register(
  Title,
  Tooltip,
  Legend,
  BarElement,
  CategoryScale,
  LinearScale,
);

export default {
  name: "BarChart",
  components: {
    Bar,
  },
  props: {
    chartId: {
      type: String,
      default: "bar-chart",
    },
    datasetIdKey: {
      type: String,
      default: "label",
    },
    width: {
      type: Number,
      default: 400,
    },
    height: {
      type: Number,
      default: 400,
    },
    cssClasses: {
      default: "",
      type: String,
    },
    styles: {
      type: Object,
      default: () => {},
    },
    plugins: {
      type: Array,
      default: () => [],
    },
  },

  data: () => ({
    data_pendidikan: [],

    chartData: {
      labels: [],

      datasets: [],
    },

    chartOptions: {
      responsive: true,
      maintainAspectRatio: false,
    },
  }),

  async mounted() {
    this.jmlpendidikan();
  },

  methods: {
    jmlpendidikan() {
      const url = process.env.VUE_APP_ASN + "statistik/jumlah/pendidikan";

      this.http
        .get(url)
        .then((response) => {
          this.data_pendidikan = response.data.data;

          const nama_label = Object.keys(this.data_pendidikan[0]).filter(
            (key) => !["jenis_kelamin", "jumlah"].includes(key),
          );

          const labelReadable = {
            sd: "SD",
            sltp: "SLTP",
            slta: "SLTA",
            d3: "D3",
            s1: "S1",
            s2: "S2",
            s3: "S3",
          };

          const labels = nama_label.map((l) => labelReadable[l]);

          const series = this.data_pendidikan.map((item) => ({
            label: item.jenis_kelamin ?? "Tidak diketahui",
            data: nama_label.map((k) => item[k]),
            backgroundColor:
              item.jenis_kelamin === "Laki-laki"
                ? "#2196F3"
                : item.jenis_kelamin === "Perempuan"
                ? "#E91E63"
                : "#9E9E9E",
          }));

          this.chartData.labels = labels;
          this.chartData.datasets = series;
        })
        .catch((error) => {
          console.log(error.response.status);
          console.log("Error", error.message);
        });
    },
  },
};
</script>
